import React from 'react';
import './Style/About.css';
import TopNavbar from './../home/TopNavbar';

const About = () => {
  return (
    <div className="about-container">
      <TopNavbar name="About Us" />

      <div className="about-card">

        {/* Legal Disclaimer Box */}
        <div className="disclaimer-box">
          <div className="disclaimer-header">
            <span className="warning-icon">⚠️</span>
            <h2>LEGAL DISCLAIMER</h2>
          </div>
          <p>
            JEE Mock Test is an independent educational platform and does not represent a government entity. We are not affiliated with, endorsed by, or connected to the National Testing Agency (NTA), IITs, or any official examination authority.
          </p>
          <div className="official-sources">
            <p><strong>Official Information Sources:</strong></p>
            <ul><br></br>
              <li><strong>JEE Main:</strong> <a href="https://jeemain.nta.nic.in" target="_blank" rel="noopener noreferrer">jeemain.nta.nic.in</a></li>
              <br></br> <li><strong>NTA:</strong> <a href="https://nta.ac.in" target="_blank" rel="noopener noreferrer">nta.ac.in</a></li>
              <br></br> <li><strong>JEE Advanced:</strong> <a href="https://jeeadv.ac.in" target="_blank" rel="noopener noreferrer">jeeadv.ac.in</a></li>
            </ul>
          </div>
        </div>

        {/* Main Header */}
        <header className="about-header">
          <h1 className="about-title">About JEE Mock Test</h1>
          <p className="about-subtitle">
            Your ultimate companion for cracking JEE Main and JEE Advanced examinations.
          </p>
        </header>

        {/* Mission Section */}
        <section className="mission-section">
          <h2>Our Mission: Empowering Engineering Aspirants</h2>
          <p>
            At JEE Mock Test, we believe that high-quality guidance for engineering entrance exams should be accessible to every student. We provide structured, syllabus-oriented, and completely free mock tests to help you boost your score.
          </p>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <h2>Comprehensive Preparation for JEE Main & Advanced</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-tag">Subject Wise</span>
              <h3>PCM Subject Mastery</h3>
              <p>Practice for Physics, Chemistry, and Mathematics tailored to the latest NTA JEE exam patterns.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">PYQ Archive</span>
              <h3>Previous Year Papers</h3>
              <p>Access solved Previous Year Questions from JEE Main and JEE Advanced papers.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">Full Mock</span>
              <h3>CBT Mode Simulation</h3>
              <p>Experience real Computer Based Test (CBT) interface with timed full-length practice tests.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">In-Depth Analysis</span>
              <h3>Performance Insights</h3>
              <p>Detailed performance analytics to highlight your strengths and weak areas in PCM.</p>
            </div>
          </div>
        </section>



        {/* Highlight Stats Banner */}
        <section className="stats-banner">
          <div className="stat-item">
            <span className="stat-number">10,000+</span>
            <span className="stat-label">MCQs & Numerical Questions</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">Main & Advanced</span>
            <span className="stat-label">Mock Content for Both</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100% Free</span>
            <span className="stat-label">For All Aspirants</span>
          </div>
        </section>
        <br></br>
        {/* Support Section */}
        <section className="about-contact">
          <p>Have questions or feedback? Contact us at  <a href="mailto:contact@mystudyplace.in">contact@mystudyplace.in</a></p>
        </section>
        <br></br> <br></br>
      </div>

    </div>
  );
};

export default About;